<template>
  <div class="addBrand">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>管理员列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px; margin-left:10px">添加管理员</div>
      </div>
      <div class="table">
        <div class="form">
          <div class="row">
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">账号:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="admin_user"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">所属部门:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-select v-model="group" :data="options" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="5">
                <div class="grid-content label">姓名:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="real_name"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">邮箱:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="email"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">电话:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="mobile"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">登录密码:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="password" type="password"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">确认密码:</div>
              </el-col>
              <el-col :span="16">
                <div class="grid-content input">
                  <el-input v-model="new_pass" type="password"></el-input>
                  <span style="color:#F64E62;margin-left:10px">*</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <div class="grid-content label">备注信息:</div>
              </el-col>

              <el-col :span="16">
                <div class="grid-content input">
                  <textarea name cols="30" rows="10" placeholder="请输入内容" id="ipt" v-model="info"></textarea>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="row" align="center">
            <div class="grid-content input">
              <button class="button" @click="submit()">提交</button>
            </div>
          </div>
        </div>
        <div class="hint">
          <span style="color:#F64E62">*</span>
          <span class="hint_sapn">为必填项</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addBrand',
  data() {
    return { serve: this.$store.state.serve,
      serve: this.$store.state.serve,
      admin_user: '',
      real_name: '',
      mobile: '',
      email: '',
      password: '',
      new_pass: '',
      group: '',
      info: '',
      //  show: 1
      options: [],
      value: ''
    }
  },
  created() {
    this.$store.state.leftTitle = '管理员列表'
    this.$store.state.topActiveId = 6
    const that = this
    this.username = this.$cookies.get('username')
    this.token = this.$cookies.get('token')
    this.axios
      //.get(this.serve+'/admin/get_admin_group', {
        .get(this.serve+'/admin/get_admin_group2', {
        params: {
          username: this.username,
          token: this.token
        }
      })
      .then(res => {
        that.options = res.data.data
      })
  },
  mounted() {},
  methods: {
    submit() {
      if (this.admin_user == '') {
        this.$message.error('账号不能为空')
        return
      } else if (this.admin_user !== '') {
        var edg = /^[0-9a-zA-Z_]{6,20}$/
        if (!edg.test(this.admin_user)) {
          this.$message.error('账号最小为6位最大为20位')
          return
        }
      }
      if (this.group == '') {
        this.$message.error('未选择所属部门')
        return
      }
      if (this.real_name == '') {
        this.$message.error('姓名不能为空')
        return
      }

      if (this.email == '') {
        this.$message.error('邮箱不能为空')
        return
      } else if (this.email !== '') {
        var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(this.email)) {
          this.$message.error('请输入有效的邮箱')
          return
        }
      }

      if (this.mobile == '') {
        this.$message.error('电话不能为空')
        return
      } else if (this.mobile !== '') {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!cel.test(this.mobile)) {
          this.$message.error('请输入有效的电话号码')
          return
        }
      }
      if (this.password == '') {
        this.$message.error('登陆密码不能为空')
        return
      } else if (this.password !== '') {
        var pass = /^[A-Za-z0-9]{6,20}$/
        if (!pass.test(this.password)) {
          this.$message.error('登陆密码最小为6位数，最大为20位数')
          return
        }
      }
      if (this.new_pass == '') {
        this.$message.error('确认密码不能为空')
        return
      }
      if (this.password !== this.new_pass) {
        this.$message.error('两次输入密码不一致')
        return
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve+'/admin/create_admin_user', {
          params: {
            admin_user: this.admin_user,
            real_name: this.real_name,
            mobile: this.mobile,
            email: this.email,
            password: this.password,
            new_pass: this.new_pass,
            group: this.group,
            info: this.info,
            username: this.username,
            token: this.token,
            config: config
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              type: 'success',
              message: '添加管理员成功'
            })
            loading.close()
            that.$router.push({ path: './permission' })
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
            loading.close()
          }else{
            this.$message.error(res.data.msg);
            loading.close()
          } 
        })
        .catch(function(err) {
          alert('操作失败')
        })
    }
  }
}
</script>
<style lang="scss">
.addBrand {
  background: #f5f5f5;
  color: #333;
  height: 1000px;
  #ipt {
    width: 282px;
    height: 180px;
    border: 1px solid rgba(221, 221, 221, 1);
    color: #606266;
    // outline: none;
    border-radius: 4px;
    outline-color: #24715d;
    // outline: 1px solid #24715d;
  }
  .hint {
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: #606266;
    position: absolute;
    top: 71px;
    right: 40px;
  }
  .button {
    margin: 0 auto;
  }

  .form-title {
    line-height: 46px;
    height: 46px;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }

  .input {
    width: 100%;
    display: flex;
    align-items: baseline;
  }
  textarea {
    height: 300px;
    width: 342px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
    position: relative;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .label {
    line-height: 40px;
  }
  .notice {
    font-size: 13px;
    color: #666;
    margin-top: 16px;
  }
  .button {
    border-radius: 5px;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .el-row {
    margin-bottom: 30px;
  }

  .switch {
    display: flex;
  }
  .el-switch {
    margin: 0 0 30px 26px;
  }
}
</style>